import React from "react";
import MiniCartContent from "theme/modules/Cart/MiniCart/MiniCartContent";

const CartNavigation = () => {
  return <MiniCartContent />;
};

export default CartNavigation;
